import AddProductModalComponent from './AddProductModalComponent'

export default AddProductModalComponent
